var map = {
	"./decidim/avatar-multiuser.png": 3328,
	"./decidim/brands/google.svg": 4047,
	"./decidim/cc-badge.png": 8138,
	"./decidim/decidim-logo.svg": 2802,
	"./decidim/default-avatar.svg": 4094,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 2722,
	"./decidim/icons.svg": 289,
	"./decidim/pattern.png": 7998,
	"./decidim/placeholder-card-g.svg": 8211,
	"./decidim/placeholder-card-l.svg": 6984,
	"./decidim/placeholder.jpg": 31,
	"./decidim/remixicon.symbol.svg": 2775,
	"./decidim/vendor/leaflet/layers-2x.png": 9802,
	"./decidim/vendor/leaflet/layers.png": 3681,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 7448,
	"./decidim/vendor/leaflet/marker-icon.png": 839,
	"./decidim/vendor/leaflet/marker-shadow.png": 8164,
	"./decidim/vendor/social-share-button/douban.svg": 6438,
	"./decidim/vendor/social-share-button/email.svg": 4211,
	"./decidim/vendor/social-share-button/facebook.svg": 4869,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 2799,
	"./decidim/vendor/social-share-button/hacker_news.svg": 8135,
	"./decidim/vendor/social-share-button/linkedin.svg": 9947,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 1684,
	"./decidim/vendor/social-share-button/pinterest.svg": 4165,
	"./decidim/vendor/social-share-button/reddit.svg": 3893,
	"./decidim/vendor/social-share-button/telegram.svg": 2460,
	"./decidim/vendor/social-share-button/tumblr.svg": 4499,
	"./decidim/vendor/social-share-button/twitter.svg": 4882,
	"./decidim/vendor/social-share-button/vkontakte.svg": 684,
	"./decidim/vendor/social-share-button/wechat.svg": 9159,
	"./decidim/vendor/social-share-button/whatsapp.svg": 6647,
	"./decidim/vendor/social-share-button/x.svg": 7475,
	"./decidim/vendor/social-share-button/xing.svg": 7749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9887;